import { useEffect } from "react";
import { registerBlockType } from "@quillforms/blocks";
import { useFormAnswers } from "@quillforms/renderer-core";

function fullNameFrom(answers: Record<string, { value?: unknown }> | undefined): string {
  const first = typeof answers?.q2?.value === "string" ? answers.q2.value.trim() : "";
  const last = typeof answers?.q3?.value === "string" ? answers.q3.value.trim() : "";
  return [first, last].filter(Boolean).join(" ");
}

registerBlockType("custom-signature", {
  supports: {
    editable: true,
  },
  attributes: {
    required: {
      type: "boolean",
      default: true,
    },
  },

  display: (props: any) => {
    const { attributes, setIsValid, setIsAnswered, setValidationErr, showNextBtn, val, setVal } = props;
    const { required = true } = attributes;

    const answers = useFormAnswers() as Record<string, { value?: unknown }> | undefined;
    const fullName = fullNameFrom(answers);
    const isSigned = typeof val === "string" && val.length > 0;

    const markSigned = (name: string) => {
      setVal(name);
      setIsAnswered(true);
      setIsValid(true);
      setValidationErr(null);
      showNextBtn(true);
    };

    useEffect(() => {
      if (isSigned) {
        // Keep the signature in sync if the patient goes back and edits their name.
        if (fullName && val !== fullName) markSigned(fullName);
        else showNextBtn(true);
        return;
      }
      setIsAnswered(false);
      setIsValid(!required);
      setValidationErr(required ? "Please tap the button to sign." : null);
      showNextBtn(!required);
    }, [fullName, isSigned]);

    if (!fullName) {
      return (
        <p className="text-sm text-red-600">
          Please enter your first and last name before signing.
        </p>
      );
    }

    return (
      <div className="w-full max-w-lg space-y-3">
        <button
          type="button"
          onClick={() => markSigned(fullName)}
          disabled={isSigned}
          className="w-full rounded-lg px-6 py-4 text-lg font-semibold text-white shadow-sm transition active:scale-95 disabled:cursor-default"
          style={{ backgroundColor: isSigned ? "#16a34a" : "#522e90" }}
        >
          {isSigned ? `Signed by ${fullName}` : `Tap to sign as ${fullName}`}
        </button>
        {isSigned && (
          <p
            className="text-2xl text-gray-800"
            style={{ fontFamily: "'Brush Script MT', 'Segoe Script', cursive" }}
          >
            {fullName}
          </p>
        )}
      </div>
    );
  },
});

export default registerBlockType;
